import { Component, Input, Output, EventEmitter } from '@angular/core';
import { GetFileIconUtilityService } from '@/app/services/utility/get-file-icon-utility.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-old-files',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './old-files.component.html',
  styleUrl: './old-files.component.css'
})
export class OldFilesComponent {
  @Input() oldFiles: any[] = [];
  @Output() removeOldFile = new EventEmitter<any>();

  constructor(private getFileIconService: GetFileIconUtilityService) {}

  getFileIcon(filePath: string): string {
    const extension = filePath.split('.').pop() || '';
    return this.getFileIconService.getFileTypeFromMime(extension);
  }

  onRemove(file: any) {
    this.removeOldFile.emit(file);
  }
}
